import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { ImgixGatsbyImage } from '@imgix/gatsby';

export const Image = ({ src, alt, ...props }) => {
  const {
    spaseekers: {
      site: {
        images: {
          hero: { url, title },
        },
      },
    },
  } = useStaticQuery(graphql`
    query ImageQuery {
      spaseekers {
        site {
          images {
            hero {
              url
              title
            }
          }
        }
      }
    }
  `);

  const imageUrl = src || url;
  const imageAlt = alt || title;

  return (
    <ImgixGatsbyImage
      src={imageUrl}
      alt={imageAlt}
      imgixParams={{ auto: 'format' }}
      {...props}
    />
  );
};

export const ImageFragment = graphql`
  fragment ImageFragment on SPASEEKERS_Image {
    url
    title
  }
`;
